import React from 'react';

export default function RegionIntro(props) {
  const { title, link, image, subtext, region } = props;

  const regionKeys = Object.keys(region);

  return (
    // Future Issue
    // 1. SEO
    // 2. user edit
    // 3. Image Handeling

    <div className="full-block">
      <div className="full-image">
        <a href={`/${link}`}>
          <picture>
            <img src={image} alt={title} />
          </picture>
        </a>
      </div>
      <div className="block-summary">
        <div className="block-title">
          <h2>
            <a href={`/${link}`}>{title}</a>
          </h2>
          <h5>{subtext ? subtext : ' '}</h5>
          {/* <p>35,000 trkkers/year</p> */}
        </div>
        <div className="block-info">
          <ul>
            {regionKeys.map((item, i) => (
              <li key={`${i}${item}`}>
                <div className="circle-wrap">
                  <span>{region[item]}</span>
                </div>
                <p>{item}</p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/screens/Explore/RegionIntro.jsx